import { generateSocketsFromSchema } from "../socket-type-inference";
import {
  getProductVariantListInputSchema,
  getProductVariantListOutputSchema,
  getProductVariantSingleInputSchema,
  productVariantFieldsSchema,
} from "../../steps/item-master/get-product-variant.step";
import type { DynamicSocketDefinition } from "./socketDefinition";

/**
 * Input sockets for Get Product Variant.
 *
 * List mode uses an `array<uuid>` socket so a list of ids is looked up in
 * this step. The single-id socket is a scalar uuid, so the engine splits a
 * list into one branch per id.
 */
export function generateGetProductVariantInputSockets(
  config: Record<string, unknown>,
): DynamicSocketDefinition[] {
  const schema =
    config.listMode === true
      ? getProductVariantListInputSchema
      : getProductVariantSingleInputSchema;
  return generateSocketsFromSchema(schema, "input");
}

/**
 * Output sockets for Get Product Variant.
 *
 * List mode collapses the catalog fields into one `variants` array so the
 * caller gets every row back together. Single mode keeps one socket per
 * field. `productId` is optional only when a missing id returns empty,
 * because that result has a null parent id.
 */
export function generateGetProductVariantOutputSockets(
  config: Record<string, unknown>,
): DynamicSocketDefinition[] {
  if (config.listMode === true) {
    return generateSocketsFromSchema(
      getProductVariantListOutputSchema,
      "output",
    );
  }

  const sockets = generateSocketsFromSchema(
    productVariantFieldsSchema,
    "output",
  );
  if (config.returnEmptyIfNotFound === true) {
    return sockets;
  }

  return sockets.map((socket) =>
    socket.id === "productId" ? { ...socket, required: true } : socket,
  );
}
